"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../../lib/utils");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileFacebookIcon = require('../../../../images/marketingsites/facebook-icon.svg');

var mobileInstagramIcon = require('../../../../images/marketingsites/instagram-icon.svg');

var mobileTwitterIcon = require('../../../../images/marketingsites/twitter-icon.svg');

var mobileLinkedInIcon = require('../../../../images/marketingsites/linkedin-icon.svg');

var SocialsFooter = function SocialsFooter(_ref) {
  var currentPage = _ref.currentPage,
      mobileOS = _ref.mobileOS;
  var ua = mobileOS.ua;
  var bottomClasses = (0, _classnames.default)('mobile-menu-bottom-section', {
    safari: ua === 'Safari'
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: bottomClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-social-media-icons"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.facebook.com/JoinEverdays/",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_facebook"), 'button_press')
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "mobile-facebook-icon",
    src: mobileFacebookIcon,
    alt: "facebook icon"
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.instagram.com/everdayslife/",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_instagram"), 'button_press')
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "mobile-instagram-icon",
    src: mobileInstagramIcon,
    alt: "instagram icon"
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://twitter.com/everdaysapp",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_twitter"), 'button_press')
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "mobile-twitter-icon",
    src: mobileTwitterIcon,
    alt: "twitter icon"
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.linkedin.com/company/everdays-inc./",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_linkedin"), 'button_press')
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "mobile-linkedin-icon",
    src: mobileLinkedInIcon,
    alt: "linkedin icon"
  }))));
};

var _default = SocialsFooter;
exports.default = _default;